/* eslint-disable */
import { getCookie } from './helpers';

class Analytics {
  init() {
    if (!getCookie('_ga').length) {
      // Google Analytics + Optimizer
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', 'UA-2834026-1', 'auto');
      ga('require', 'GTM-MTWS5W5');
      // End Google Analytics + Optimizer
    }

    // Google Tag Manager
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-5SVS6WN');
    // End Google Tag Manager
  }

  /**
   * FUNCTION FOR DATALAYER.PUSH CONDITIONS
   */
  removeAccentMarkAndUppercase(param) {

    const lowerCaseString = param.toLowerCase().trim(),
      chars = { 'á':'a', 'é':'e', 'í':'i', 'ó':'o', 'ú':'u', 'ñ':'n' },
      regExp=/[áéíóúñ]/ig;

    const noAccentString = lowerCaseString.replace(regExp,function(e){ return chars[e] });

    return noAccentString;
  }

  pushData(obj) {
    window.dataLayer.push({
      ...obj,
      event: 'gaEvent'
    });
  }
}

export default new Analytics();
